import React from "react";
import { Container } from "react-grid-system";
import { Link } from "react-router-dom";

// STYLES
import styled from "styled-components";

// IMAGES
import Network_1 from "../../images/BannerTop/bg-rede.png";
import Restaurantes_1 from "../../images/BannerTop/bg-restaurantes.png";
import Products_1 from "../../images/BannerTop/bg-produtos.png";
import Receitas_1 from "../../images/BannerTop/bg-receitas.png";
import Events_1 from "../../images/BannerTop/bg-receitas.png";
import Workshops_1 from "../../images/BannerTop/bg-workshops.jpg";

export default class BannerTop extends React.Component {
  render() {
    const { t, type, i18n } = this.props;
    let image;

    if (type === 2) {
      image = Network_1;
    } else if (type === 3) {
      image = Restaurantes_1;
    } else if (type === 4) {
      image = Products_1;
    } else if (type === 5) {
      image = Receitas_1;
    } else if (type === 6) {
      image = Network_1;
    } else if (type === 7) {
      image = Workshops_1;
    } else {
      image = Events_1;
    }

    const BannerText = styled.div`
      text-align: center;
    `;

    const Title = styled.h1`
      font-family: Bazar;
      font-size: ${type === 2 ? "80px" : "100px"};
      font-weight: 500;
      text-shadow: 0 0 10px 0 rgba(48, 48, 48, 0.6);
      color: #ffffff;
      text-transform: uppercase;
      margin: 0;
      margin-top: ${type === 2 ? "100px" : ""};

      @media screen and (max-width: 991px) {
        font-size: 40px;
      }
      @media screen and (max-width: 767px) {
        font-size: 32px;
      }
    `;

    const BannerContent = styled.div`
      width: 100%;
      height: 580px;

      @media screen and (max-width: 991px) {
        height: ${type !== 2 ? "400px" : "580px"};
      }
    `;
    const BannerBackground = styled.div`
      width: 100%;
      height: 580px;
      background-size: cover;
      background-position: fixed;
      background-position: center;

      @media screen and (max-width: 991px) {
        height: ${type !== 2 ? "400px" : "580px"};
      }
    `;
    // TO DO
    return (
      <BannerContent>
        <BannerBackground style={{ backgroundImage: "url(" + image + ")" }}>
          <Mask>
            <BannerText>
              {type !== 2 && <TitleBig>{this.props.title}</TitleBig>}
              {type === 2 && (
                <Container>
                  <Title>{this.props.title}</Title>
                  <Text>{t("RedeTextoBanner")}</Text>
                  {i18n.language === "pt" && (
                    <Link to="/pt/rede/candidatura">
                      <BtnBanner>CANDIDATAR</BtnBanner>
                    </Link>
                  )}
                  {i18n.language === "en" && (
                    <Link to="/en/network/apply">
                      <BtnBanner>APPLY</BtnBanner>
                    </Link>
                  )}
                  {i18n.language === "de" && (
                    <Link to="/de/netzwerk/anwendung">
                      <BtnBanner>ANWENDUNG</BtnBanner>
                    </Link>
                  )}
                  {i18n.language === "fr" && (
                    <Link to="/fr/reseau/candidature">
                      <BtnBanner>APLICAR</BtnBanner>
                    </Link>
                  )}
                  {i18n.language === "es" && (
                    <Link to="/es/red/aplicar">
                      <BtnBanner>APLICAR</BtnBanner>
                    </Link>
                  )}

                  {i18n.language === "ja" && (
                    <Link to="/ja/network/apply">
                      <BtnBanner>応募する</BtnBanner>
                    </Link>
                  )}
                </Container>
              )}
            </BannerText>
          </Mask>
        </BannerBackground>
      </BannerContent>
    );
  }
}

const Mask = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const TitleBig = styled.h1`
  font-family: Bazar;
  font-size: 100px;
  font-weight: 500;
  text-shadow: 0 0 10px 0 rgba(48, 48, 48, 0.6);
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;
  text-align: center;

  @media screen and (max-width: 991px) {
    font-size: 62px;
  }
  @media screen and (max-width: 767px) {
    font-size: 40px;
  }
`;
const Text = styled.p`
  max-width: 767px;
  color: #ffffff;
  font-size: 18px;
  line-height: 26px;
  text-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  margin-top: 24px;
  margin-bottom: 24px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: 991px) {
    font-size: 16px;
  }
`;
const BtnBanner = styled.div`
  width: 202px;
  height: 45px;
  line-height: 45px;
  border: 1px solid #ffffff;
  border-radius: 4px;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #fff;
    color: #000000;
  }
`;



// WEBPACK FOOTER //
// ./src/components/bannertop/bannertop.component.js